import { Payment, StartPaymentResponse } from "@ssc-booking/api-contracts"

export default StartPaymentResponse.build({
    id: "1d5ff490-8d54-429b-a955-c1d9a01ea0cc",
    payment: Payment.as.cybersource({
        payload: {
            transaction_uuid: "1d5ff490-8d54-429b-a955-c1d9a01ea0cc",
            locale: "en-US",
            transaction_type: "sale,create_payment_token",
            reference_number: "71459-22",
            amount: "1",
            currency: "USD",
            payer_authentication_transaction_mode: "S",
            bill_to_forename: "Test",
            bill_to_surname: "Test",
            bill_to_email: "info@doubleloop.io",
            signed_date_time: "2022-04-20T08:41:55Z",
            unsigned_field_names: "",
            signed_field_names:
                "access_key,profile_id,transaction_uuid,signed_field_names,unsigned_field_names,signed_date_time,locale,transaction_type,reference_number,amount,currency,payer_authentication_transaction_mode,bill_to_forename,bill_to_surname,bill_to_email",
            profile_id: "4FFADEDB-1C43-4C50-B97D-350E9335ED69",
            access_key: "86edb18665203546806a3f6c71531eea",
        },
        signature: "BPRPWApk1ewEOJgHvffaHiu+AFvcsU2F0kuc/pNTfKI=",
    }),
})
